var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from "vue";
import Component from "vue-class-component";
import DataForm from "~/components/common/data-form.vue";
import DataBox from "~/components/common/data-box.vue";
import AnnexImportConfig from "./annex-import-config.vue";
import { State } from "vuex-class";
import { PageService } from "~/utils/page.service";
import { SortService } from "~/utils/sort.service";
import { Layout, Dependencies } from "~/core/decorator";
import { Emit } from "vue-property-decorator";
import { UploadFileService } from "~/services/common-service/upload-file.service";
import { ImportExcelCaseService } from "~/services/dataimp-service/import-excel-case.service";
import { ImportOthersDataExcelRecordService } from "~/services/dataimp-service/import-others-data-excel-record.service";
var AnnexImportList = /** @class */ (function (_super) {
    __extends(AnnexImportList, _super);
    function AnnexImportList() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        // 导入类型
        _this.templateType = "IMPORT_CASE_ANNEX";
        _this.searchModel = {
            principalName: "",
            importDataExcelStatus: "",
            templateType: _this.templateType //导入类型
        };
        /**弹窗 */
        _this.dialog = {
            importCase: false,
            importCaseDetail: false
        };
        _this.dataSet = [];
        _this.batchNumber = "";
        _this.loading = {
            state: false
        };
        return _this;
    }
    AnnexImportList.prototype.mounted = function () {
        var _this = this;
        this.refreshData();
        // 收到消息通知时更新未读消息
        this.$reminder.addMessageListener().subscribe(function (data) {
            // 补充材料导入[IMPORT_CASE_ANNEX] 补充材料导入确认[IMPORT_ANNEX_CONFIRMED]
            if (data.messageType === "IMPORT_ANNEX" ||
                data.messageType === "IMPORT_ANNEX_CONFIRMED") {
                _this.refreshData();
            }
        });
    };
    AnnexImportList.prototype.refreshData = function () {
        var _this = this;
        this.loading.state = true;
        this.importOthersDataExcelRecordService
            .getImportOthersDataExcelList(this.searchModel, this.pageService, this.sortService, this.loading)
            .subscribe(function (data) {
            _this.dataSet = data;
        });
    };
    /**
     * 案件导入
     */
    AnnexImportList.prototype.caseImportDialogOpen = function () {
        this.dialog.importCase = true;
    };
    /**
     * 错误信息下载
     */
    AnnexImportList.prototype.errorTipsDownload = function (row) {
        this.uploadFileService.getFileStreamById(row.resultUrl);
    };
    /**
     * 取消导入
     */
    AnnexImportList.prototype.cancelImport = function (id) {
        var _this = this;
        this.$confirm("您确定取消此案件吗？", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning"
        }).then(function () {
            _this.importOthersDataExcelRecordService
                .cancelOthersExcelImpCase(id)
                .subscribe(function (data) {
                _this.$message.success("取消导入成功!"), _this.refreshData();
            });
        });
    };
    /**
     * 确认导入
     */
    AnnexImportList.prototype.confirmImport = function (id) {
        var _this = this;
        this.$confirm("您确定要导入此案件吗？", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning"
        }).then(function () {
            _this.importOthersDataExcelRecordService
                .confirmOthersExcelImpCase(id)
                .subscribe(function (data) {
                _this.$message.success("导入成功!"), _this.refreshData();
            });
        });
    };
    /**
     * 对账撤销
     */
    AnnexImportList.prototype.revertCick = function (row) {
        var _this = this;
        this.$confirm("确认要对此批次进行撤销", "提示").then(function () {
            _this.importOthersDataExcelRecordService
                .revokeOthersExcelImp(row.id)
                .subscribe(function (data) {
                _this.$message.success("操作成功");
                _this.refreshData();
            });
        });
    };
    /**
     * 查看详情
     */
    AnnexImportList.prototype.viewDetail = function (rowData) { };
    /**
     * 下载模板
     */
    AnnexImportList.prototype.downLoadTemplate = function () {
        var _this = this;
        this.importExcelCaseService
            .getSystemTemplate({ templateType: this.templateType })
            .subscribe(function (data) {
            if (data)
                _this.uploadFileService
                    .getFileStreamById(data.fileId)
                    .subscribe(function () { return _this.$message.success("下载成功"); });
        });
    };
    __decorate([
        Dependencies(PageService)
    ], AnnexImportList.prototype, "pageService", void 0);
    __decorate([
        Dependencies(SortService)
    ], AnnexImportList.prototype, "sortService", void 0);
    __decorate([
        Dependencies(UploadFileService)
    ], AnnexImportList.prototype, "uploadFileService", void 0);
    __decorate([
        Dependencies(ImportExcelCaseService)
    ], AnnexImportList.prototype, "importExcelCaseService", void 0);
    __decorate([
        Dependencies(ImportOthersDataExcelRecordService)
    ], AnnexImportList.prototype, "importOthersDataExcelRecordService", void 0);
    __decorate([
        State
    ], AnnexImportList.prototype, "principalList", void 0);
    __decorate([
        Emit("onClickCaseDetail")
    ], AnnexImportList.prototype, "viewDetail", null);
    AnnexImportList = __decorate([
        Layout("workspace"),
        Component({
            components: {
                DataForm: DataForm,
                DataBox: DataBox,
                AnnexImportConfig: AnnexImportConfig
            }
        })
    ], AnnexImportList);
    return AnnexImportList;
}(Vue));
export default AnnexImportList;
